class PublisherSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('.publisher-search-input');
    this.grid = this.closest('.publishers-page').querySelector('[data-publisher-grid]');
    this.emptyState = this.grid ? this.grid.querySelector('[data-publisher-empty]') : null;

    if (!this.input || !this.grid) return;

    this.input.addEventListener('input', debounce(this.applyFilter.bind(this), 200));
  }

  applyFilter() {
    const query = this.input.value.trim().toLowerCase();
    let visibleCount = 0;

    this.grid.querySelectorAll('.card-publisher').forEach((card) => {
      const name = (card.dataset.publisherName || '').toLowerCase();
      const matches = query === '' || name.indexOf(query) !== -1;
      card.classList.toggle('is-hidden', !matches);
      if (matches) visibleCount += 1;
    });

    if (this.emptyState) {
      this.emptyState.classList.toggle('is-visible', visibleCount === 0);
    }
  }
}

if (!customElements.get('publisher-search')) {
  customElements.define('publisher-search', PublisherSearch);
}

// Publishers are filtered out of the paginated `collections` object (50 per
// page), so matches can be spread across several pages. Fetch the remaining
// pages through the Section Rendering API and merge every card into the one
// visible grid — no pagination links are shown. Cards are deduped by
// collection handle so re-renders (e.g. in the theme editor) never repeat a
// publisher.
(function () {
  function cardKey(card) {
    return card.dataset.publisherKey || card.dataset.publisherName || '';
  }

  function loadAllPublisherPages() {
    var grid = document.querySelector('[data-publisher-grid]');
    if (!grid || grid.dataset.publishersLoading === 'true') return;
    grid.dataset.publishersLoading = 'true';

    var totalPages = parseInt(grid.dataset.totalPages || '1', 10);
    var sectionId = grid.dataset.sectionId;
    if (totalPages <= 1 || !sectionId) return;

    var requests = [];
    for (var page = 2; page <= totalPages; page += 1) {
      var url = window.location.pathname + '?page=' + page + '&section_id=' + encodeURIComponent(sectionId);
      requests.push(
        fetch(url)
          .then(function (response) { return response.ok ? response.text() : ''; })
          .catch(function () { return ''; })
      );
    }

    Promise.all(requests).then(function (pages) {
      var emptyState = grid.querySelector('[data-publisher-empty]');
      var parser = new DOMParser();
      var seen = {};

      grid.querySelectorAll('.card-publisher').forEach(function (card) {
        seen[cardKey(card)] = true;
      });

      pages.forEach(function (html) {
        if (!html) return;
        var cards = parser.parseFromString(html, 'text/html').querySelectorAll('.card-publisher');
        cards.forEach(function (card) {
          var key = cardKey(card);
          if (seen[key]) return;
          seen[key] = true;
          if (emptyState) {
            grid.insertBefore(card, emptyState);
          } else {
            grid.appendChild(card);
          }
        });
      });

      var search = document.querySelector('publisher-search');
      if (search && search.grid && search.input) {
        search.applyFilter();
      } else if (emptyState) {
        emptyState.classList.toggle('is-visible', grid.querySelector('.card-publisher') === null);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadAllPublisherPages);
  } else {
    loadAllPublisherPages();
  }
})();
